import {useSignalEffect} from '@preact/signals-react'
import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {Dropdown} from 'primereact/dropdown'
import {forwardRef, useCallback, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {convertKeyToLabel} from '../table-utils/TableUtils'
import './style/Dropdown.css'
const DropdownUtils = forwardRef(
    (
        {
            id,
            optionsList = [],
            placeholder,
            className,
            defaultValue = null,
            callBack = () => {},
            onSelectedAll = () => {},
            customDetail = false,
            inputId = '',
            disabled = false,
            required = false,
        },
        ref,
    ) => {
        useSignals()
        useImperativeHandle(ref, () => ({
            value: handleGetData(),
        }))
        const {translateKeys, translateCommons} = TranslateUtils()
        const [selected, setSelected] = useState(defaultValue)
        const handleGetData = () => {
            return selected
        }

        const panelVisible = useSignal(false)

        const handleOnChange = value => {
            setSelected(value)

            if (id === 'selectAll') {
                onSelectedAll(id, value)
            }

            if (!!callBack) {
                callBack(value, id)
            }
        }

        //#region Prevent Scroll Helper
        useSignalEffect(() => {
            const contentDiv = document.querySelector(
                '#blockscroll-sidebar .p-sidebar-content',
            )

            toggleBlockScroll(contentDiv, panelVisible.value)

            return () => {
                if (!!contentDiv) {
                    contentDiv.removeEventListener('wheel', preventScroll)
                    contentDiv.removeEventListener('touchmove', preventScroll)
                }
            }
        })

        const preventScroll = event => {
            event.preventDefault()
            event.stopPropagation()
        }

        const toggleBlockScroll = useCallback((contentDiv, isVisible) => {
            if (!!contentDiv) {
                if (!!isVisible) {
                    contentDiv.addEventListener('wheel', preventScroll, {
                        passive: false,
                    })
                    contentDiv.addEventListener('touchmove', preventScroll, {
                        passive: false,
                    })
                } else {
                    contentDiv.removeEventListener('wheel', preventScroll)
                    contentDiv.removeEventListener('touchmove', preventScroll)
                }
            }
        }, [])
        //#endregion

        return (
            <div key={id} className="relative">
                <span
                    className={`${
                        customDetail ? 'p-float-label' : ''
                    } col-12 p-0 `}>
                    <Dropdown
                        className={`${className} ${
                            customDetail ? 'custom-detail' : ''
                        } `}
                        inputId={inputId}
                        options={optionsList}
                        optionLabel="label"
                        optionValue="value"
                        value={selected}
                        defaultValue={defaultValue ? defaultValue : null}
                        onChange={e => handleOnChange(e.value)}
                        placeholder={placeholder}
                        disabled={disabled}
                        filter
                        filterBy="label"
                        filterPlaceholder={translateCommons('Search here')}
                        emptyMessage={translateCommons('No records found')}
                        showFilterClear
                        resetFilterOnHide
                        showClear
                        emptyFilterMessage={translateCommons(
                            'No results found',
                        )}
                        style={{
                            '--inputColor': 'rgba(68, 184, 166, 0.1)',
                        }}
                        onShow={() => {
                            panelVisible.value = true
                        }}
                        onHide={() => {
                            panelVisible.value = false
                        }}
                    />
                    {customDetail && (
                        <label className="ml-0" htmlFor={inputId}>
                            {' '}
                            {translateKeys(convertKeyToLabel(inputId))}
                        </label>
                    )}
                </span>
            </div>
        )
    },
)

export default DropdownUtils
